// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"1949239f","266":"2fea65be","373":"87053825","386":"bb859f0d","417":"29e7fec6","476":"d69c78c0","560":"e13fec3a","562":"ffe27d51","720":"3027206b","744":"a00846af","773":"24340f5b","790":"b43e0664","884":"a3f79535"}[chunkId] + ".chunk.js";
};